import { render, staticRenderFns } from "./youtubeNote.vue?vue&type=template&id=80adecce&scoped=true&"
import script from "./youtubeNote.vue?vue&type=script&lang=js&"
export * from "./youtubeNote.vue?vue&type=script&lang=js&"
import style0 from "./youtubeNote.vue?vue&type=style&index=0&id=80adecce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80adecce",
  null
  
)

export default component.exports